export default [
	{
		path: 'subscription/one-year-offer',
		name: 'account-subscription-one-year-offer',
		redirect: {
			name: 'account-subscription-one-quarter-offer-cancellation',
		},
	},

	{
		path: 'subscription/one-quarter-offer-cancellation',
		name: 'account-subscription-one-quarter-offer-cancellation',
		props: { scenarioId: 'one-quarter-offer-cancellation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/five-dollar-offer-forever',
		name: 'account-subscription-five-dollar-offer-forever',
		props: { scenarioId: 'five-dollar-offer-forever' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/reactivation',
		name: 'account-subscription-reactivation',
		props: { scenarioId: 'reactivation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/downgrade',
		name: 'account-subscription-downgrade',
		props: { scenarioId: 'downgrade' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/reactivation-declined',
		name: 'account-subscription-reactivation-declined',
		props: { scenarioId: 'reactivation-declined' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresExpiredSubscription: true,
		},
	},

	{
		path: 'subscription/subscription-cancellation',
		name: 'subscription-cancellation',
		props: { scenarioId: 'subscription-cancellation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/subscription-cancellation-hard',
		name: 'subscription-cancellation-hard',
		props: { scenarioId: 'subscription-cancellation-hard' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/subscription-pause-3-months',
		name: 'account-subscription-pause-3-months',
		props: { scenarioId: 'subscription-pause-3-months' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},
	{
		path: 'subscription/subscription-pause-1-month',
		name: 'account-subscription-pause-1-month',
		props: { scenarioId: 'subscription-pause-1-month' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},

	{
		path: 'subscription/one-time-offer-reactivation-5',
		name: 'one-time-offer-reactivation-5',
		props: { scenarioId: 'one-time-offer-reactivation-5' },
		component: () =>
			import(
				/* webpackChunkName: "one-time-offer-reactivation-5" */ '@/views/account/subscription/AccountSubscription.vue'
			),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},
	{
		path: 'subscription/subscription-cancellation-with-reactivation',
		name: 'account-subscription-cancellation-with-reactivation',
		props: { scenarioId: 'subscription-cancellation-with-reactivation' },
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/subscription/AccountSubscription.vue'),
		meta: {
			requiresUser: true,
			requiresSubscription: true,
		},
	},
]
